import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Container, Dimmer, Table, Card,
  Button, Avatar, Page
} from "tabler-react";
import PhotoModal from '../../components/modal/photoModal';
import SearchInput from '../../components/searchInput';

const RecordsTable = ({
  headers,
  records,
  openMainModal,
  loading,
  reload,
  setTravellerAsPrime,
  searchQuery,
  onSearch
}) => {
  const [modalPhoto, setModalPhoto] = useState(null)
  const history = useHistory()

  return (
    <Container>
      {modalPhoto &&
        <PhotoModal photo={modalPhoto} close={() => setModalPhoto(null)} />
      }

      <Page.Header>
        <Page.Title>Users</Page.Title>
      </Page.Header>
      <Card>
        <Dimmer active={loading} loader={loading}>
          <Card.Header>
            <Card.Options>
              <SearchInput value={searchQuery} onSubmit={onSearch} />
              <Button
                className="ml-2"
                icon="plus"
                color="primary"
                size="md"
                onClick={() => openMainModal('user-create', null, reload)}
              >
                Create User
              </Button>
            </Card.Options>
          </Card.Header>

          {!loading && records.length < 1 ? (
            <div className="alert alert-primary m-0">
              No Users to show!
            </div>
          ) : (
            <div className="table-responsive-wrapper">
              <Table hasOutline striped>
                <Table.Header>
                  {headers.map((head, i) => (
                    <Table.ColHeader key={`tableHeader-${i}`}>
                      {head}
                    </Table.ColHeader>
                  ))}
                  <Table.ColHeader>Actions</Table.ColHeader>
                </Table.Header>

                <Table.Body>
                  {records.map((r, i) => (
                    <Table.Row 
                      key={i} 
                      className={`${Math.abs(new Date() - new Date(r.createdAt)) / 36e5 <= 24 ? 'newUser' : ''}`}
                    >
                      {Object.keys(r).map((k, idx) => {
                        if (k === 'id' || k === 'roles') { return null }
                        if (k === 'image') {
                          return (
                            <Table.Col key={`${i}-${k}`}>
                              <Avatar
                                size="sm"
                                imageURL={r['image']}
                                onClick={() => setModalPhoto(r['image'])}
                                className="clickable"
                              />
                            </Table.Col>
                          );
                        }
                        if (k === 'username') {
                          return (
                            <Table.Col key={`${i}-${k}`}>
                              <span className="clickable" onClick={() => openMainModal('user-view', r.id)}>
                                {r[k]}
                              </span>
                            </Table.Col>
                          )
                        }
                        else {
                          return (<Table.Col key={`${i}-${k}`}>{r[k]}</Table.Col>);
                        }
                      })}
                      
                      <Table.Col>
                        <div className="actions-wrap">
                          <Button
                            outline
                            color="secondary"
                            size="sm"
                            onClick={() => openMainModal('user-edit', r.id, reload)}
                          >
                            Edit
                          </Button>

                          <Button
                            outline
                            color="danger"
                            className="ml-2 mr-2"
                            size="sm"
                            onClick={() => openMainModal('users--delete', r.id, reload)}
                          >
                            Delete
                          </Button>

                          {r.roles && r.roles.indexOf('Traveller') !== -1 && r.roles.indexOf('PrimeTraveller') === -1 && (
                            <Button
                              outline
                              color="success"
                              size="sm"
                              onClick={() => setTravellerAsPrime(r.id)}
                            >
                              Prime
                            </Button>
                          )}

                          <Button
                            outline
                            color="secondary"
                            className="ml-2"
                            size="sm"
                            onClick={() => history.push(`/users/userShipments/${r.id}`)}
                          >
                            Shipments
                          </Button>

                          <Button
                            outline
                            color="secondary"
                            className="ml-2"
                            size="sm"
                            onClick={() => history.push(`/users/userTrips/${r.id}`)}
                          >
                            Trips
                          </Button>
                        </div>
                      </Table.Col>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>
          )}
        </Dimmer>
      </Card>
    </Container>
  );
}

export default RecordsTable;